import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox';
import CloseIcon from '../../../../assets/svg/close.svg?react';
import DownloadIcon from '../../../../assets/svg/download.svg?react';
import FJCommunityIcon from '../../../../assets/svg/community/community.svg?react';
import DeleteBlackIcon from '../../../../assets/svg/delete-black.svg?react';
import FJVideoEditIcon from '../../../../assets/svg/community/trim-video-Edit-black.svg?react';
import styles from './FJCommunitySelectAll.module.less';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import FJPrivacySetting from '../../FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import { useState, useRef, useEffect } from 'react';
const FJCommunitySelectAll = props => {
    const {
        list,
        selectList,
        multiDownload,
        multiDelete,
        setSelectList,
        clearSelected,
        multiVideoEdit,
        multiPrivacySettingChange,
        multiPrivacy,
        isShow,
        hidePrivacySetting = false,
    } = props;
    const selectNumber = selectList.length;
    const [batchDownloadLoading, setBatchDownloadLoading] = useState(false);
    const [videoEditLoading, setVideoEditLoading] = useState(false);
    const privacySettingRef = useRef(null);

    useEffect(() => {
        if (!isShow && privacySettingRef.current) {
            privacySettingRef.current.hide();
        }
    }, [isShow, privacySettingRef]);
    const _clearSelected = () => {
        clearSelected && clearSelected();
        setSelectList([]);
    };
    const isSelectedAll = selectList?.length >= list?.length;
    const _selectAll = () => {
        if (isSelectedAll) {
            setSelectList([]);
        } else {
            setSelectList(list.map(i => i?.id));
        }
    };
    const _onBatchDownload = () => {
        if (batchDownloadLoading) {
            return;
        }
        setBatchDownloadLoading(true);
        multiDownload &&
            multiDownload(selectList, () => {
                setBatchDownloadLoading(false);
            });
    };

    const _multiVideoEdit = e => {
        e.stopPropagation();
        e.preventDefault();
        if (videoEditLoading) {
            return;
        }
        setVideoEditLoading(true);
        multiVideoEdit &&
            multiVideoEdit(selectList, () => {
                setVideoEditLoading(false);
            });
    };
    const _multiPrivacySettingChange = (value, callback) => {
        multiPrivacySettingChange && multiPrivacySettingChange(selectList, value, callback);
    };

    const _renderButton = () => {
        return (
            <>
                <div className={styles.split_line} />
                <FJButton
                    text={FJLocalStore._('download')}
                    onClick={_onBatchDownload}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon />}
                    className={styles.download_btn}
                    isLoading={batchDownloadLoading}
                    textClassName={styles.download_btn_text}
                />
                <div className={styles.split_line} />
                {!hidePrivacySetting && (
                    <FJPrivacySetting
                        value={multiPrivacy}
                        onChange={_multiPrivacySettingChange}
                        hideShareToSociety={true}
                        placement='topCenter'
                        ref={privacySettingRef}
                        renderTrigger={({ ref, onClick }) => {
                            return (
                                <FJToolTip title={'visibility'}>
                                    <div style={{ marginRight: 12 }} ref={ref} onClick={onClick}>
                                        <FJIconButton
                                            icon={<FJCommunityIcon />}
                                            style={{ padding: 0, width: 40, height: 40 }}
                                            isLoading={videoEditLoading}
                                            loadingSize={16}
                                        />
                                    </div>
                                </FJToolTip>
                            );
                        }}
                    />
                )}
                <FJToolTip title={'delete'}>
                    <div style={{ marginRight: 12 }}>
                        <FJIconButton
                            icon={<DeleteBlackIcon />}
                            onClick={() => multiDelete(selectList)}
                            style={{ padding: 0, width: 40, height: 40 }}
                            disabled={selectList.length === 0}
                        />
                    </div>
                </FJToolTip>
                <FJButton
                    text={FJLocalStore._('video-editor')}
                    onClick={_multiVideoEdit}
                    style={{ marginRight: 12 }}
                    icon={<FJVideoEditIcon />}
                    className={styles.video_edit_btn}
                    textClassName={styles.video_edit_btn_text}
                />
            </>
        );
    };

    return (
        <div className={classNames(styles.select_all_box, isShow ? styles.show : styles.hide)}>
            <FJCheckBox dataChange={_selectAll} selected={isSelectedAll} value={FJLocalStore._('select-all')} />
            <div className={styles.middle}>
                <div className={styles.select_number}>{selectNumber}</div>

                <div className={styles.select_desc}>
                    {FJLocalStore._(selectList?.length <= 1 ? 'project-selected' : 'projects-selected')}
                </div>
                {_renderButton()}
            </div>
            <div className={styles.close_btn_box} onClick={_clearSelected}>
                <CloseIcon className={styles.close_icon} />
            </div>
        </div>
    );
};
FJCommunitySelectAll.propTypes = {
    list: PropTypes.array,
    selectList: PropTypes.array,
    multiDownload: PropTypes.func,
    multiDelete: PropTypes.func,
    setSelectList: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
    clearSelected: PropTypes.func,
    multiVideoEdit: PropTypes.func,
    multiPrivacySettingChange: PropTypes.func,
    multiPrivacy: PropTypes.string,
    isShow: PropTypes.bool,
    hidePrivacySetting: PropTypes.bool,
};
export default FJCommunitySelectAll;
